import React from "react";
import { Link } from "react-router-dom";
import { Dots } from "react-dot-patterns";
import heroSectionImage from "../../../assets/service-hero-image.jpg";

const HeroSection = () => {
  return (
    <div className="automobile-hero-section-wrapper">
      <div className="dots1">
        <Dots
          col={6}
          row={4}
          size={5}
          rotate={0}
          margin={8}
          color={"#f3792c"}
          item={null}
          style={{}}
          evenRowShift={10}
        />
      </div>
      <div className="dots2">
        <Dots
          col={3}
          row={4}
          size={5}
          rotate={0}
          margin={5}
          color={"#f3792c"}
          item={null}
          style={{}}
          evenRowShift={-20}
        />
      </div>
      <div className="row">
        <div className="col-12 col-md-6 p-4">
          <div className="detail-container">
            <h1>
              Drive Efficiency
              <br /> in <span>Automotive Operations</span>
            </h1>
            <p>
              The automotive industry demands precision, efficiency, and the
              ability to manage complex supply chains. Soori Corporation’s
              software solutions help automotive companies optimize asset
              management, improve production workflows, and meet industry
              regulations with ease.
            </p>
            <Link to="/industry">Book A Meeting</Link>
          </div>
        </div>
        <div className="col-12 col-md-6 p-4">
          <div className="image-container">
            <img src={heroSectionImage} alt="image" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
